"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createUseSignalREffect = void 0;
const hermes_channel_1 = __importDefault(require("hermes-channel"));
const react_1 = require("react");
function createUseSignalREffect(context) {
    const useSignalREffect = (events, callback, deps) => {
        (0, react_1.useEffect)(() => {
            let _events;
            function _callback(args) {
                callback(...args);
            }
            // backward compatible array should remove
            if (!Array.isArray(events)) {
                _events = [events];
            }
            else {
                _events = events;
            }
            _events.forEach((event) => {
                var _a;
                (_a = context.on) === null || _a === void 0 ? void 0 : _a.call(context, event);
                hermes_channel_1.default.on(event, _callback);
            });
            return () => {
                _events.forEach((event) => {
                    var _a;
                    (_a = context.off) === null || _a === void 0 ? void 0 : _a.call(context, event);
                    hermes_channel_1.default.off(event, _callback);
                });
            };
            // eslint-disable-next-line react-hooks/exhaustive-deps
        }, deps);
    };
    return useSignalREffect;
}
exports.createUseSignalREffect = createUseSignalREffect;
//# sourceMappingURL=hooks.js.map